export default {
    route: {
        index: '首页',
        register: '供应商注册',
        editorNotice: '公告编辑',
        previewNotice: '公告预览',
        tenderList: '公告管理',
        mipIframe: 'MIP审批',
        tenderDetails: '我的投标详情',
        payBidDetail: '投标费用详情',
        payFreight: '投标费用详情',
        refundApplication: '投标保证金退款',
        supAnnoList: '招标公告',
        supPreviewNotice: '公告详情',
        myBidding: '我的投标',
        tenderCost: '投标费用',
        tendermanagement: '招标管理',
        tenderdocument: '招标方案',
        supplierbid: '供应商应标管理',
        graderesult: '综合评分结果',
        roundquote: '轮次报价',
        tenderresult: '招标结果',
        tendertemplate: '招标模板',
        templatedetails: '招标模板详情',
        comprehensivegrade: '综合打分',
        baseConfig: '类型配置',
        keyData: '供应商主数据',
        mipMessage: '审批详情',
        accountManage: '账号管理',
        driverInfo: '司机管理',
        personInfo: '人员账号管理',
        vehicleInfo: '车辆管理',
        contractUphold: '合同维护',
        warningConfigure: '预警配置',
        warningTask: '预警任务',
        contractSigning: '合同签署',
        fileConfiguration: '文件配置',
        payfileConfiguration: '付款条件',
        keyDataDetail: '供应商详情',
        mipExamine: '变更审批',
        basicInfo: '基础信息',
        warehouseInfo: '仓库管理',
        wtMipIframe: '预警任务',
        cuMipIframe: '合同维护流程审批',
        toDolist: '待办模板',
        toDodetails: '待办模板详情',
        toDoLesseeList: '租户模板映射',
        toDoLesseeDe: '租户模板详情',
        toDoItems: '待办事项',
        toDoItemsDeitails: '待办事项详情',
        myTender: '报价详情',
        costDetail: '报价详情',
        addPhysicalStorage: '新增物理仓',
        physicalStorage: '物理仓',
        blackDriverMIP: '供应商司机拉黑MIP审批',
        dailyAssessment: '日常考核',
        rectificationTask: '整改任务',
        monthlyAssessment: '月度考核',
        monthlyAssessScore: '月度考核得分',
        rushOrderAuthApply: '抢单权限申请',
        driverAddSupplier: '司机加入供应商申请',
        driverDelegateLetter: '司机委派函管理',
        legalPerform: '月度绩效',
        performRectify: '绩效整改',
        warehouseDelegationLetter: '仓储委派函管理',
        warehouseDelegationApprove: '仓库人员详情',
        loaderSalaryConfirm: '装卸人员工资确认',
        performanceAdjustment: '仓储绩效整改',
        abnormalAssess: '异常考核',
        idleResource: '发布资源',
    }
};
